import { en } from './messages/en';
import type { MessageId } from './messages/en';
import type { TranslateParams } from './types';

/** Replace `{name}` placeholders; unknown placeholders are left visible (easier to spot than a blank). */
export function interpolate(template: string, params?: TranslateParams): string {
  if (!params) return template;
  return template.replace(/\{(\w+)\}/g, (placeholder, name: string) => {
    const value = params[name];
    return value === undefined ? placeholder : String(value);
  });
}

/**
 * Pure lookup in the message table: the message, else the key itself (so a missing key is visible
 * but never crashes the UI).
 */
export function translate(key: MessageId, params?: TranslateParams): string {
  const template: string | undefined = en[key];
  return interpolate(template ?? key, params);
}

export type TFunction = (key: MessageId, params?: TranslateParams) => string;
